import { IGetRelatedRecipeUsecase } from '@modules/recipes/domain/ports/getRelatedRecipe.usecase.port';
import { left, right } from '@shared/utils/either.utils';
import { shuffleArrayWithLimitOutput } from '@shared/utils/random.utils';
import { IRecipeRelatedRecipeRepository } from '../ports/relatedRecipe.repository.port';
export class GetRelatedRecipeUsecase implements IGetRelatedRecipeUsecase {
  constructor(private readonly recipeRelatedRecipeRepository: IRecipeRelatedRecipeRepository) {}
  async handle(recipeId: number, isLoggedIn: boolean): IGetRelatedRecipeUsecase.getRelatedRecipeOutput {
    const result = isLoggedIn ? await this.recipeRelatedRecipeRepository.getRelatedRecipeWithPersonalized(recipeId) : await this.recipeRelatedRecipeRepository.getRelatedRecipe(recipeId);
    const value = result.value;
    if (result.isLeft()) return left(value);
    const randomFourRecipe = shuffleArrayWithLimitOutput(value, 4);
    return right(randomFourRecipe);
  }
}